module.exports = __webpack_public_path__ + "images/qr-code/error.d04bdb73176b32293bf7.svg";